export default {
  saved: {
    en: 'Saved',
  },
  free: {
    en: 'Free',
  },
}
